<template>
    <div class="diagram-choose-line">
        <div v-for="lData in lineType" :key="lData.value" class="diagram-choose-line-item" @click="clickChooseLineItem(lData)">
            <diagram-hand-item :itemType="lData.value"></diagram-hand-item>
            <span v-if="choosedLineValue == lData.valueNum" class="diagram-choose-t-icon"><i class="iconfont icon-selected"></i></span>
        </div>
    </div>
</template>

<script>
import DiagramHandItem from '../../components/diagram/DiagramHandItem.vue';
export default {
    name: 'DiagramChooseLine',
    components: { DiagramHandItem },
    computed: {
        curChoosedLine() {
            return this.$store.state.diagram.curChoosedLine;
        },
        choosedLineData() {
            return this.$store.state.diagram.choosedLineData;
        },
        choosedLineValue() {
            return this.$store.state.diagram.choosedLineValue;
        }
    },
    data() {
        return {
            lineType: [
                {value: 'syin', valueNum: 1, text: '少阴'},
                {value: 'syang', valueNum: 2, text: '少阳'},
                {value: 'lyin', valueNum: 3, text: '老阴'},
                {value: 'lyang', valueNum: 4, text: '老阳'},
            ]
        }
    },
    mounted: function() {

    },
    methods: {
        clickChooseLineItem(itemData) {
            this.$store.state.diagram.choosedLineValue = itemData.valueNum;
            this.$store.state.diagram.showChooseLine = false;
            this.$store.state.diagram.choosedLineData[this.curChoosedLine] = itemData.valueNum;
            console.log('clickItem----', this.$store.state.diagram.choosedLineData)
        }
    }
}
</script>